import PermissionsHelper from 'auth/helper/PermissionHelper';
import { printShippingLabelApi } from '../../../../apis/seller-center/shipments';
import { Toast } from '../../../../common/web-view';
import { getErrorString } from '../../../../utils/utils';
import { PERMISSION_KEY_CONSIGNMENT } from '@constants/permission-constants';
import { RESPONSE_TYPES } from '@constants/generic-constants';

export const handlePrintShippingLabel = async (consignmentId, shipmentService) => {
  try {
    const response = await printShippingLabelApi(consignmentId, shipmentService === 'leopard' ? RESPONSE_TYPES?.json : RESPONSE_TYPES?.blob);
    if (shipmentService === 'leopard') {
      window.open(response.url, '_blank');
    } else {
      const pdfUrl = URL.createObjectURL(response);
      window.open(pdfUrl, '_blank');
    }
  } catch (error) {
    Toast.error(getErrorString(error));
    throw error;
  }
};

export const filterActionsBasedOnPermissions = (actions = [], PERMISSION_KEY) => {
  return actions?.filter((action) => {
    const splitUrl = action?.url?.split('/');
    const actionKey = splitUrl?.[splitUrl?.length - 1];
    return PermissionsHelper.getPermissions(
      action?.url?.includes('consignment') ? PERMISSION_KEY_CONSIGNMENT : PERMISSION_KEY,
      actionKey,
    );
  });
};
